import { render, staticRenderFns } from "./product-size-select.vue?vue&type=template&id=52cf3c50&scoped=true&"
import script from "./product-size-select.vue?vue&type=script&lang=js&"
export * from "./product-size-select.vue?vue&type=script&lang=js&"
import style0 from "./product-size-select.vue?vue&type=style&index=0&id=52cf3c50&scoped=true&lang=scss&"
import style1 from "./product-size-select.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cf3c50",
  null
  
)

export default component.exports